import { Component, ViewChild, Input } from '@angular/core';
import { MachineHistorySearchComponent } from '../../Core/Shared/MachineHistoryComponent/MachineHistorySearch.component';

@Component({
  selector: 'DmMachineHistorySearch',
  templateUrl: './DmMachineHistorySearch.component.html'
})
export class DmMachineHistorySearchComponent {
}
